import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';

import { PacksService } from '../../services/packs.service';
import * as PacksActions from '../actions/packs.actions';
@Injectable({ providedIn: 'root' })
export class PacksEffects {
    private packsService = inject(PacksService);
    private router = inject(Router);
    private actions$ = inject(Actions); 

    loadPacks$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PacksActions.loadPacks),
            switchMap(() =>
                this.packsService.getPacks().pipe(
                    map(packs =>
                        PacksActions.loadPacksSuccess({ packs: packs })
                    ),
                    catchError(error =>
                        of(PacksActions.loadPacksFailure({ error }))
                    )
                )
            )
        )
    );

    loadPacksSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PacksActions.loadPacksSuccess),
                tap(({ packs }) => {
                })
            ),
        { dispatch: false }
    );

    loadPacksFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(PacksActions.loadPacksFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );
}